import { useEffect, useMemo, useRef, useState } from "react";
import "./Customers.css";

import nawaloka from "../../assets/clients/Nawaloke.png";
import alubomulla from "../../assets/clients/NATC.png";
import roofing from "../../assets/clients/Roofing Lanka.png";
import brightKennel from "../../assets/clients/Bright Kennel.png";
import sjIndustries from "../../assets/clients/SJI.png";
import auricode from "../../assets/clients/Auricode.jpeg";


export default function Customers() {
  const sectionRef = useRef(null);
  const [paused, setPaused] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  const clients = useMemo(
    () => [
      { name: "Nawaloka Medical Centres", logo: nawaloka },
      { name: "Alubomulla Trade Center", logo: alubomulla },
      { name: "Bright Kennel", logo: brightKennel },
      { name: "Auricode Solutions", logo: auricode },
      { name: "SJ Industries", logo: sjIndustries },
      { name: "Roofing Lanka", logo: roofing },
    ],
    []
  );

  // duplicate list for seamless marquee
  const loopLogos = useMemo(() => [...clients, ...clients], [clients]);

  // reveal animation (no blur)
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const raf = requestAnimationFrame(() => el.classList.add("is-mounted"));

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          io.disconnect();
        }
      },
      { threshold: 0.18 }
    );

    io.observe(el);

    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, []);

  // pause when tab hidden
  useEffect(() => {
    const onVis = () => setIsHidden(document.hidden);
    onVis();
    document.addEventListener("visibilitychange", onVis);
    return () => document.removeEventListener("visibilitychange", onVis);
  }, []);

  const runState = paused || isHidden ? "paused" : "running";

  return (
    <section className="customersSection" id="clients" ref={sectionRef}>
      <div className="container customersContainer">
        {/* Header */}
        <div className="customersHead reveal" style={{ "--d": "0ms" }}>
          <div className="customersPill">TRUSTED BY</div>
          <h2 className="customersTitle">Our Valuable Customers</h2>
          <p className="customersSub">
            We’re proud to work with these trusted businesses
          </p>
        </div>

        {/* Logo band */}
        <div
          className="customersBand reveal"
          style={{ "--d": "140ms", "--run": runState }}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
          onTouchStart={() => setPaused(true)}
          onTouchEnd={() => setPaused(false)}
        >
          <div className="customersMask" aria-label="Customer logos">
            <div className="customersTrack">
              {loopLogos.map((c, idx) => (
                <div className="logoCard" key={`${c.name}-${idx}`} title={c.name}>
                  <img
                    className="logoImg"
                    src={c.logo}
                    alt={c.name}
                    loading="lazy"
                    draggable="false"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
